import { ROUTE_PATH } from './consts';

export const createBrandPageUrl = brandId =>
  ROUTE_PATH.replace(':brandId', brandId);
